<template lang="html">
	<li :class="itemClasses">
		<div class="omapi-multi-column__primary">
			<div class="omapi-multi-column__title" v-html="notification.title"></div>
			<div class="omapi-multi-column__text" v-html="notification.content"></div>
			<div class="omapi-multi-column__buttons">
				<a
					v-for="(button, buttonType) in notification.btns"
					:key="buttonType"
					:class="buttonType === 'main' ? 'omapi-button omapi-button__secondary omapi-button__small' : ''"
					:href="button.url"
					:target="getTarget(button)"
					@click="handleClick"
					v-html="getButtonText(button)"
				></a>
				<span v-if="hasMultipleButtons"> | </span>
				<a
					v-show="canDismiss"
					href="#"
					class="dismiss"
					@click.prevent="processDismissNotification"
				>
					Dismiss
				</a>
				<div v-if="loading" class="om-circle-loading"></div>
			</div>
		</div>
		<div class="omapi-multi-column__secondary upper">{{ getDate }}</div>
	</li>
</template>

<script lang="js">
export default {
	props : {
		/**
		 * The notification object.
		 *
		 * @type {Object}
		 */
		notification : {
			type     : Object,
			required : true,
		},
		/**
		 * Whether this notification is active.
		 *
		 * @type {Boolean}
		 */
		active : {
			type    : Boolean,
			default : true,
		},
		/**
		 * Whether this notification is being shown in-drawer.
		 *
		 * @type {Object}
		 */
		inDrawer : {
			type    : Boolean,
			default : false,
		},
	},
	data () {
		return {
			loading : false,
			closed  : false,
		}
	},
	computed : {
		style () {
			const style = {}
			if (this.loading) {
				style.opacity = '.05'
			}

			return style
		},
		itemClasses () {
			let classes = 'omapi-' + this.$get('notification.type', 'default-notification')
			if (this.closed) {
				classes += ' om-notification-closed'
			}

			if (this.loading) {
				classes += ' om-notification-loading'
			}

			return classes
		},
		hasMultipleButtons () {
			return this.notification.btns && 1 < Object.keys(this.notification.btns).length
		},
		getDate () {
			return this.$moment.utc(this.notification.created * 1000).tz(this.$moment.tz.guess()).fromNow()
		},
		canDismiss () {
			return !this.notification.dismissed && false !== this.notification.canDismiss
		},
	},
	methods : {
		processDismissNotification () {
			this.loading = true
			this.$emit('remove', this.notification)
		},
		getButtonText (button) {
			return button.text
		},
		getTarget (button) {
			if (button.target) {
				return button.target
			}

			if (this.$router.getRouteForUrl(button.url)) {
				return null
			}

			try {
				const url = new URL(button.url)
				return url.host === window.location.host ? null : '_blank'
			} catch (e) {}

			return null
		},
		handleClick (event) {
			if ('#' === event.target.href || window.location.href + '#' === event.target.href) {
				return event.preventDefault()
			}

			// If we're on one of our query routes...
			const route = this.$router.getRouteForUrl(event.target.href)
			if (route) {
				event.preventDefault()

				// Then trigger the route
				this.$router.push({ name: route.name })

				this.$emit('clicked', event)
			}
		},
	},
}
</script>
<style lang="scss" scoped>
	.om-notification-loading {
		opacity: .5;
	}
	.om-circle-loading {
		width: 20px;
		height: 20px;
		background-size: 20px;
		margin: 0;
		display: inline-block;
		position: relative;
		top: 5px;
		margin-left: 10px;
	}
	.dismiss {
		display: inline-block;
	}
</style>
